/* eslint-disable */

export const protobufPackage = "squareup.multipass";

/** The state of the trusted device token. */
export let TrustedDevice = /*#__PURE__*/function (TrustedDevice) {
  TrustedDevice[TrustedDevice["UNTRUSTED"] = 0] = "UNTRUSTED";
  TrustedDevice[TrustedDevice["TRUSTED"] = 1] = "TRUSTED";
  TrustedDevice[TrustedDevice["EXPIRED"] = 2] = "EXPIRED";
  TrustedDevice[TrustedDevice["CHANGED"] = 3] = "CHANGED";
  TrustedDevice[TrustedDevice["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return TrustedDevice;
}({});
export let TwoFactorEnrollmentSource = /*#__PURE__*/function (TwoFactorEnrollmentSource) {
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["UNKNOWN"] = 0] = "UNKNOWN";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["ACCOUNT_SETTINGS"] = 1] = "ACCOUNT_SETTINGS";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["LOG_IN_REQUIREMENT"] = 2] = "LOG_IN_REQUIREMENT";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["TWO_FACTOR_PROMO_PROMPT"] = 3] = "TWO_FACTOR_PROMO_PROMPT";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["CHECKING"] = 4] = "CHECKING";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["PAYROLL"] = 5] = "PAYROLL";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["IDV"] = 6] = "IDV";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["DORMANT_RECOVERY"] = 7] = "DORMANT_RECOVERY";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["MANDATORY_ENROLLMENT"] = 8] = "MANDATORY_ENROLLMENT";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["MANDATORY_PROMO_PROMPT"] = 9] = "MANDATORY_PROMO_PROMPT";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["ATO_SELF_SERVE_RECOVERY"] = 10] = "ATO_SELF_SERVE_RECOVERY";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["STEP_UP_AUTHENTICATION"] = 11] = "STEP_UP_AUTHENTICATION";
  TwoFactorEnrollmentSource[TwoFactorEnrollmentSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return TwoFactorEnrollmentSource;
}({});

/** Scoped session type that indicates from where / how the session should be validated. */
export let ScopedSession = /*#__PURE__*/function (ScopedSession) {
  ScopedSession[ScopedSession["SQUARE"] = 0] = "SQUARE";
  ScopedSession[ScopedSession["CAPITAL_PARTNERSHIPS"] = 1] = "CAPITAL_PARTNERSHIPS";
  ScopedSession[ScopedSession["BUYER"] = 2] = "BUYER";
  ScopedSession[ScopedSession["CAPITAL_CONSUMER"] = 3] = "CAPITAL_CONSUMER";
  ScopedSession[ScopedSession["HIRING_WEB"] = 4] = "HIRING_WEB";
  ScopedSession[ScopedSession["SQUARE_BUYER"] = 5] = "SQUARE_BUYER";
  ScopedSession[ScopedSession["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return ScopedSession;
}({});
export let LogoutReason = /*#__PURE__*/function (LogoutReason) {
  LogoutReason[LogoutReason["REASON_UNKNOWN"] = 0] = "REASON_UNKNOWN";
  LogoutReason[LogoutReason["USER_INITIATED"] = 1] = "USER_INITIATED";
  LogoutReason[LogoutReason["MACHINE_INITIATED"] = 2] = "MACHINE_INITIATED";
  LogoutReason[LogoutReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return LogoutReason;
}({});
export let Verification = /*#__PURE__*/function (Verification) {
  Verification[Verification["NO_VERIFICATION"] = 0] = "NO_VERIFICATION";
  Verification[Verification["TWO_FACTOR"] = 1] = "TWO_FACTOR";
  Verification[Verification["PASSWORD"] = 2] = "PASSWORD";
  Verification[Verification["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return Verification;
}({});
export let AliasTypeScope_AliasType = /*#__PURE__*/function (AliasTypeScope_AliasType) {
  AliasTypeScope_AliasType[AliasTypeScope_AliasType["UNKNOWN"] = 0] = "UNKNOWN";
  AliasTypeScope_AliasType[AliasTypeScope_AliasType["PHONE"] = 1] = "PHONE";
  AliasTypeScope_AliasType[AliasTypeScope_AliasType["EMAIL"] = 2] = "EMAIL";
  AliasTypeScope_AliasType[AliasTypeScope_AliasType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return AliasTypeScope_AliasType;
}({});
export let ChangeAliasTypeScope_ChangeAliasType = /*#__PURE__*/function (ChangeAliasTypeScope_ChangeAliasType) {
  ChangeAliasTypeScope_ChangeAliasType[ChangeAliasTypeScope_ChangeAliasType["UNKNOWN"] = 0] = "UNKNOWN";
  ChangeAliasTypeScope_ChangeAliasType[ChangeAliasTypeScope_ChangeAliasType["ADD"] = 1] = "ADD";
  ChangeAliasTypeScope_ChangeAliasType[ChangeAliasTypeScope_ChangeAliasType["REMOVE"] = 2] = "REMOVE";
  ChangeAliasTypeScope_ChangeAliasType[ChangeAliasTypeScope_ChangeAliasType["UPDATE"] = 3] = "UPDATE";
  ChangeAliasTypeScope_ChangeAliasType[ChangeAliasTypeScope_ChangeAliasType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return ChangeAliasTypeScope_ChangeAliasType;
}({});

/**
 * Contains the details about a trusted device include it's token, expiry, and owning person token.
 * Used as an alternative to cookies for devices that don't support cookies.
 */

/** All the data about a single secure contact method. */

/** Activation phone supplied at the time of payment onboarding/IDV. Sourced from Onboarding. */

/** Recovery method type for recovering an account. */

export let RecoveryMethodScope_RecoveryMethod = /*#__PURE__*/function (RecoveryMethodScope_RecoveryMethod) {
  RecoveryMethodScope_RecoveryMethod[RecoveryMethodScope_RecoveryMethod["UNKNOWN"] = 0] = "UNKNOWN";
  RecoveryMethodScope_RecoveryMethod[RecoveryMethodScope_RecoveryMethod["ACTIVATION_PHONE"] = 1] = "ACTIVATION_PHONE";
  RecoveryMethodScope_RecoveryMethod[RecoveryMethodScope_RecoveryMethod["NEW_PHONE"] = 2] = "NEW_PHONE";
  RecoveryMethodScope_RecoveryMethod[RecoveryMethodScope_RecoveryMethod["IDENTITY_VERIFICATION_PHONE"] = 3] = "IDENTITY_VERIFICATION_PHONE";
  RecoveryMethodScope_RecoveryMethod[RecoveryMethodScope_RecoveryMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return RecoveryMethodScope_RecoveryMethod;
}({});

/** Recovery event type for distinguishing which request type was used during the recovery flow. */

export let RecoveryEventTypeScope_RecoveryEventType = /*#__PURE__*/function (RecoveryEventTypeScope_RecoveryEventType) {
  RecoveryEventTypeScope_RecoveryEventType[RecoveryEventTypeScope_RecoveryEventType["UNKNOWN"] = 0] = "UNKNOWN";
  RecoveryEventTypeScope_RecoveryEventType[RecoveryEventTypeScope_RecoveryEventType["CODE_SEND"] = 1] = "CODE_SEND";
  RecoveryEventTypeScope_RecoveryEventType[RecoveryEventTypeScope_RecoveryEventType["CODE_VERIFY"] = 2] = "CODE_VERIFY";
  RecoveryEventTypeScope_RecoveryEventType[RecoveryEventTypeScope_RecoveryEventType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return RecoveryEventTypeScope_RecoveryEventType;
}({});

/** Recovery reason for distinguishing the reason a recovery event was requested. */

export let RecoveryReasonScope_RecoveryReason = /*#__PURE__*/function (RecoveryReasonScope_RecoveryReason) {
  RecoveryReasonScope_RecoveryReason[RecoveryReasonScope_RecoveryReason["DORMANT_RECOVERY"] = 0] = "DORMANT_RECOVERY";
  RecoveryReasonScope_RecoveryReason[RecoveryReasonScope_RecoveryReason["MANDATORY_2FA"] = 1] = "MANDATORY_2FA";
  RecoveryReasonScope_RecoveryReason[RecoveryReasonScope_RecoveryReason["ATO_SELF_SERVE_RECOVERY"] = 2] = "ATO_SELF_SERVE_RECOVERY";
  RecoveryReasonScope_RecoveryReason[RecoveryReasonScope_RecoveryReason["STEP_UP_AUTHENTICATION"] = 3] = "STEP_UP_AUTHENTICATION";
  RecoveryReasonScope_RecoveryReason[RecoveryReasonScope_RecoveryReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return RecoveryReasonScope_RecoveryReason;
}({});

/** All the data about a recovery detail. */

/** Recovery event for a given person. */

/** The merchant item displayed on Launchpad page */

/** The service item displayed on Launchpad page */

/** The type of the service */
export let LaunchpadServiceItem_LaunchpadServiceType = /*#__PURE__*/function (LaunchpadServiceItem_LaunchpadServiceType) {
  LaunchpadServiceItem_LaunchpadServiceType[LaunchpadServiceItem_LaunchpadServiceType["UNKNOWN"] = 0] = "UNKNOWN";
  LaunchpadServiceItem_LaunchpadServiceType[LaunchpadServiceItem_LaunchpadServiceType["PAYSTUBS"] = 1] = "PAYSTUBS";
  LaunchpadServiceItem_LaunchpadServiceType[LaunchpadServiceItem_LaunchpadServiceType["BANKING"] = 2] = "BANKING";
  LaunchpadServiceItem_LaunchpadServiceType[LaunchpadServiceItem_LaunchpadServiceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return LaunchpadServiceItem_LaunchpadServiceType;
}({});
export let TwoFactorVerificationSourceScope_TwoFactorVerificationSource = /*#__PURE__*/function (TwoFactorVerificationSourceScope_TwoFactorVerificationSource) {
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["UNKNOWN"] = 0] = "UNKNOWN";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["LOGIN"] = 1] = "LOGIN";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["STEP_UP_AUTHENTICATION"] = 2] = "STEP_UP_AUTHENTICATION";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["CHANGE_2FA_SETTINGS"] = 3] = "CHANGE_2FA_SETTINGS";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["LOGIN_TWO_FACTOR_BYPASS"] = 4] = "LOGIN_TWO_FACTOR_BYPASS";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["PASSKEY_REGISTRATION"] = 5] = "PASSKEY_REGISTRATION";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["PASSKEY_DEREGISTRATION"] = 6] = "PASSKEY_DEREGISTRATION";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["SCA_VERIFICATION"] = 7] = "SCA_VERIFICATION";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["PASSKEY_LOGIN_TWO_FACTOR_BYPASS"] = 8] = "PASSKEY_LOGIN_TWO_FACTOR_BYPASS";
  TwoFactorVerificationSourceScope_TwoFactorVerificationSource[TwoFactorVerificationSourceScope_TwoFactorVerificationSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return TwoFactorVerificationSourceScope_TwoFactorVerificationSource;
}({});

/**
 * These timestamps represent unique Session#two_factor_provided_timestamp values when a session's
 * 2FA status is escalated and promoted from a non-upgraded session to a 2FA upgraded session.
 * They are different values because we should be able to use them to determine the reason why a
 * session may have been escalated.
 */

export let TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp = /*#__PURE__*/function (TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp) {
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["UNKNOWN"] = 0] = "UNKNOWN";
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["TWO_FACTOR_ENROLL_AVOID_DISRUPTION_2FA_TIMESTAMP"] = 1] = "TWO_FACTOR_ENROLL_AVOID_DISRUPTION_2FA_TIMESTAMP";
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["LOGIN_TWO_FACTOR_BYPASS_2FA_TIMESTAMP"] = 2] = "LOGIN_TWO_FACTOR_BYPASS_2FA_TIMESTAMP";
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["EMAIL_TWO_FACTOR_2FA_TIMESTAMP"] = 3] = "EMAIL_TWO_FACTOR_2FA_TIMESTAMP";
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["PASSKEY_LOGIN_2FA_BYPASS_TIMESTAMP"] = 4] = "PASSKEY_LOGIN_2FA_BYPASS_TIMESTAMP";
  TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp[TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return TwoFactorEscalationTimestampScope_TwoFactorEscalationTimestamp;
}({});

/** All the data about a single method of 2FA. */

/** Email 2FA details. Currently only a valid 2FA method for 2FA Upgrades/Verifications. */

/**
 * Used in combination with HttpErrorProtoOverHttpHandler. If an HttpError message exists in
 * the response side channel, it will override the http response with the given fields. Currently,
 * only the status code will be overridden.
 */

export let Device_Type = /*#__PURE__*/function (Device_Type) {
  Device_Type[Device_Type["DO_NOT_USE"] = 0] = "DO_NOT_USE";
  Device_Type[Device_Type["WEB"] = 1] = "WEB";
  Device_Type[Device_Type["MOBILE"] = 2] = "MOBILE";
  Device_Type[Device_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return Device_Type;
}({});
export let AccountLockoutReasonScope_AccountLockoutReason = /*#__PURE__*/function (AccountLockoutReasonScope_AccountLockoutReason) {
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["UNKNOWN"] = 0] = "UNKNOWN";
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["PASSWORD_COMMON"] = 1] = "PASSWORD_COMMON";
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["PASSWORD_COMPROMISED"] = 2] = "PASSWORD_COMPROMISED";
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["DORMANT_ACCOUNT"] = 3] = "DORMANT_ACCOUNT";
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["MANDATORY_2FA"] = 4] = "MANDATORY_2FA";
  AccountLockoutReasonScope_AccountLockoutReason[AccountLockoutReasonScope_AccountLockoutReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return AccountLockoutReasonScope_AccountLockoutReason;
}({});
export let CredentialLockTypeScope_CredentialLockType = /*#__PURE__*/function (CredentialLockTypeScope_CredentialLockType) {
  CredentialLockTypeScope_CredentialLockType[CredentialLockTypeScope_CredentialLockType["RECOVERABLE_LOCK"] = 0] = "RECOVERABLE_LOCK";
  CredentialLockTypeScope_CredentialLockType[CredentialLockTypeScope_CredentialLockType["PERMANENT_LOCK"] = 1] = "PERMANENT_LOCK";
  CredentialLockTypeScope_CredentialLockType[CredentialLockTypeScope_CredentialLockType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return CredentialLockTypeScope_CredentialLockType;
}({});

/** Types of captcha that can be verified. */

export let CaptchaTypeScope_CaptchaType = /*#__PURE__*/function (CaptchaTypeScope_CaptchaType) {
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["UNKNOWN"] = 0] = "UNKNOWN";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["RECAPTCHA_V2_CHECKBOX"] = 1] = "RECAPTCHA_V2_CHECKBOX";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["RECAPTCHA_V2_ANDROID"] = 2] = "RECAPTCHA_V2_ANDROID";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["APPLE_DEVICECHECK"] = 3] = "APPLE_DEVICECHECK";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["SQUID_MCAP"] = 4] = "SQUID_MCAP";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["RECAPTCHA_ENTERPRISE_V2_CHECKBOX"] = 5] = "RECAPTCHA_ENTERPRISE_V2_CHECKBOX";
  CaptchaTypeScope_CaptchaType[CaptchaTypeScope_CaptchaType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return CaptchaTypeScope_CaptchaType;
}({});

/** Serialization container for session id */

/**
 * The type of the session determines expiration, idle time, and termination conditions. This should
 * match squareup.multipass.service.DeviceDetails.Type until we can migrate to using this instead.
 */

export let SessionTypeScope_SessionType = /*#__PURE__*/function (SessionTypeScope_SessionType) {
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["WEB"] = 0] = "WEB";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["API"] = 1] = "API";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["OAUTH"] = 2] = "OAUTH";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["OAUTH_PERM"] = 3] = "OAUTH_PERM";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["RESTRICTED"] = 4] = "RESTRICTED";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["OAUTH_SHORT"] = 5] = "OAUTH_SHORT";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["WEB_BUYER"] = 6] = "WEB_BUYER";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["OAUTH_PERSON"] = 7] = "OAUTH_PERSON";
  SessionTypeScope_SessionType[SessionTypeScope_SessionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return SessionTypeScope_SessionType;
}({});

/**
 * This message is added to the RPC side-channel for requests that are forwarded from Multipass to
 * another DC due to retryable redis failures. If this message is present in the side-channel, then
 * don't forward the request again to prevent cycles.
 */

/** Additional query params that should be added as part of the password reset link. */

/** Passkey credential object as exposed by multipass and multipassfe APIs */

export let DeregisterPasskeyScope_Step = /*#__PURE__*/function (DeregisterPasskeyScope_Step) {
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["UNKNOWN"] = 0] = "UNKNOWN";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["CHECK_RATE_LIMIT"] = 1] = "CHECK_RATE_LIMIT";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["PASSWORD_VERIFICATION"] = 2] = "PASSWORD_VERIFICATION";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["CHECK_PASSWORD"] = 3] = "CHECK_PASSWORD";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["TWO_FACTOR_VERIFICATION"] = 4] = "TWO_FACTOR_VERIFICATION";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["PASSED_VERIFICATION"] = 5] = "PASSED_VERIFICATION";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["DEREGISTRATION"] = 6] = "DEREGISTRATION";
  DeregisterPasskeyScope_Step[DeregisterPasskeyScope_Step["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return DeregisterPasskeyScope_Step;
}({});